module.exports = __webpack_public_path__ + "img/T1C_rc_24.94c1146e.png";